import Vue from 'vue'
import uploadcare from 'uploadcare-widget'
import { byteToMegabyte, maxSize, setErrorMessages } from '@/utils/uploadcare'

const UploadCarePlugin = {
  install(Vue, globalOptions) {
    Vue.prototype.$uploadcare = {
      openDialog(options, $i18n) {
        const { maxFileSize, ...optionsWithoutExtra } = options
        const cleanedOptions = maxFileSize
          ? { ...optionsWithoutExtra, validators: [maxSize(maxFileSize)] }
          : options

        if (maxFileSize) {
          const errorMessages = {
            size: {
              title: $i18n.t('uploadcare_image__size_restriction_message', [
                `${byteToMegabyte(maxFileSize)}MB`,
              ]),
            },
          }

          setErrorMessages($i18n.locale, errorMessages)
        }

        const dialog = uploadcare.openDialog(null, {
          ...globalOptions,
          ...cleanedOptions,
        })
        dialog.progress(() => {
          const iframes = dialog.dialogElement[0].querySelectorAll('iframe')
          const locale = $i18n.locale
          iframes.forEach((iframe) => {
            if (iframe.classList.contains('uploadcare--tab__iframe')) {
              const urlParts = iframe.src.split('?')
              urlParts[1] = 'lang=' + locale.toLowerCase()
              iframe.src = urlParts.join('?')
            }
          })
        })

        return dialog
      },
    }
  },
}

Vue.use(UploadCarePlugin, {
  publicKey: process.env.UPLOADCARE_API_KEY,
  imagesOnly: true,
  previewStep: true,
})
